/* ───────────────────────────────────────────────────────────────
   Fairylicense Favourites store — the client-side wishlist.

   Loaded globally (layout/theme.liquid), so hearts + the header badge
   work on every page; the Favourites page (sections/fl-wishlist.liquid)
   listens for the change event to reveal saved cards.

   Storage: localStorage 'frls_faves' = JSON array of product HANDLES.
   (One product per colourway → the handle IS the colourway identity.)
   Private-mode / blocked storage degrades to an in-memory list rather
   than breaking the hearts.

   Public API (window.FRLSFaves):
     items()        → fresh array of saved handles (never the live ref)
     has(handle)    → boolean
     count()        → number
     toggle(handle) → boolean (true if now saved)
     remove(handle) → void
   Emits 'frls:faves-change' on document after every mutation.

   Wires automatically (click-delegated on document):
     .card__heart[data-handle]   → toggle (card grids everywhere)
     [data-save][data-handle]     → toggle (PDP "Save")
   and reflects saved state onto those + any [data-faves-count] badge.
   ─────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var KEY = 'frls_faves';
  var EVENT = 'frls:faves-change';
  var memory = []; // fallback when localStorage is unavailable

  function storageOk() {
    try {
      var t = '__frls_test__';
      localStorage.setItem(t, '1');
      localStorage.removeItem(t);
      return true;
    } catch (e) {
      return false;
    }
  }
  var persistent = storageOk();

  /* Validate + de-dupe into a fresh array of non-empty string handles. */
  function clean(arr) {
    var out = [], seen = {};
    if (!Array.isArray(arr)) return out;
    for (var i = 0; i < arr.length; i++) {
      var h = arr[i];
      if (typeof h === 'string' && h && !seen[h]) { seen[h] = true; out.push(h); }
    }
    return out;
  }

  function read() {
    if (!persistent) return memory.slice();
    try {
      var raw = localStorage.getItem(KEY);
      return raw ? clean(JSON.parse(raw)) : [];
    } catch (e) {
      return [];
    }
  }

  /* Persist a NEW array (callers never mutate in place), then broadcast. */
  function write(next) {
    var value = clean(next);
    if (persistent) {
      try { localStorage.setItem(KEY, JSON.stringify(value)); }
      catch (e) { persistent = false; memory = value; }
    } else {
      memory = value;
    }
    try {
      document.dispatchEvent(new CustomEvent(EVENT, { detail: { items: value.slice() } }));
    } catch (e) {
      var ev = document.createEvent('CustomEvent');
      ev.initCustomEvent(EVENT, false, false, { items: value.slice() });
      document.dispatchEvent(ev);
    }
    return value;
  }

  var FRLSFaves = {
    items: function () { return read(); },
    has: function (handle) { return read().indexOf(handle) !== -1; },
    count: function () { return read().length; },
    toggle: function (handle) {
      if (typeof handle !== 'string' || !handle) return false;
      var current = read();
      var idx = current.indexOf(handle);
      if (idx === -1) {
        write(current.concat([handle]));
        return true;
      }
      write(current.slice(0, idx).concat(current.slice(idx + 1)));
      return false;
    },
    remove: function (handle) {
      var current = read();
      var idx = current.indexOf(handle);
      if (idx !== -1) write(current.slice(0, idx).concat(current.slice(idx + 1)));
    }
  };
  window.FRLSFaves = FRLSFaves;

  /* ── DOM reflection ── keep every heart / save / badge in sync. */
  function reflect() {
    var saved = read();
    var set = {};
    for (var i = 0; i < saved.length; i++) set[saved[i]] = true;

    var hearts = document.querySelectorAll('.card__heart[data-handle]');
    for (var j = 0; j < hearts.length; j++) {
      var hOn = !!set[hearts[j].getAttribute('data-handle')];
      hearts[j].setAttribute('aria-pressed', hOn ? 'true' : 'false');
      hearts[j].classList.toggle('is-saved', hOn);
    }

    var saves = document.querySelectorAll('[data-save][data-handle]');
    for (var k = 0; k < saves.length; k++) {
      var sOn = !!set[saves[k].getAttribute('data-handle')];
      saves[k].setAttribute('aria-pressed', sOn ? 'true' : 'false');
      saves[k].classList.toggle('is-saved', sOn);
      var label = saves[k].querySelector('[data-save-label]');
      if (label) label.textContent = sOn ? 'Saved' : 'Save';
    }

    var count = saved.length;
    var badges = document.querySelectorAll('[data-faves-count]');
    for (var m = 0; m < badges.length; m++) {
      badges[m].textContent = count;
      badges[m].hidden = count === 0;
    }
  }

  function onClick(e) {
    if (!e.target.closest) return;
    var toggleEl = e.target.closest('.card__heart[data-handle], [data-save][data-handle]');
    if (!toggleEl) return;
    e.preventDefault();
    FRLSFaves.toggle(toggleEl.getAttribute('data-handle'));
  }

  function init() {
    document.addEventListener('click', onClick);
    document.addEventListener(EVENT, reflect);
    reflect();
    // Broadcast initial state so late-binding listeners (e.g. wishlist section JS
    // bundled separately) can apply saved handles on first load.
    write(read());
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
